import { useQuery } from '@apollo/client';
import { talkUserSessionEntitlementsQuery } from 'Services/BeGateway/Talk/__generated__/talkUserSessionEntitlementsQuery';
import { USER_SESSION_ENTITLEMENTS_QUERY } from 'Services/BeGateway/Talk/talk.services';
import { defaultQueryConfig, BEGatewayQueryContext } from 'utils/apollo';

export default () => {
  const { data, loading, error } = useQuery<talkUserSessionEntitlementsQuery>(
    USER_SESSION_ENTITLEMENTS_QUERY,
    {
      ...defaultQueryConfig,
      ...BEGatewayQueryContext,
    },
  );

  const entitlements = data?.unmindSessionEntitlements;

  const sessionLimit = entitlements?.allowance?.limit;
  const remainingSessions = entitlements?.allowance?.remaining;
  const expiryDate: Date | null = entitlements?.period?.endDate
    ? new Date(entitlements.period.endDate)
    : null;
  const sessionsExpired =
    expiryDate !== null && expiryDate.getTime() < Date.now();

  return {
    loading,
    error,
    sessionLimit,
    remainingSessions,
    expiryDate,
    sessionsExpired,
  };
};
